/**
 * Shows driver manuals when user searches.
 *
 * @module feature/DriverManualSearch
 */
import AjaxHandler from 'AjaxHandler';
import 'bootstrap/js/dist/collapse.js';

/**
 * Loads driver manua data, populates manual list and expands results list.
 *
 * @requires module:project/Common.AjaxHandler
 * @requires bootstrap/js/dist/collapse
 * @memberof module:feature/DriverManualSearch
 * @version 1.0.0
 * @author Peter van Gennip <peter.van.gennip@valtech.nl>
 */

class DriverManualSearch {
    /**
     * Initializes internal variables, configuration.
     * @param {jQueryElememt} $element DOM Element to be upgraded.
     * @param {object} options Configuration options.
     *
     */
    constructor($element) {
        this.$element = $($element);
        this.data = null;
        this.lang = this.$element.attr('data-lang');
        this.introSlideTemplate = null;
        this.resultsFound = null;
        this.$tpl = this.$element.find('.js-tpl').clone().html();
        this.$searchBtn = this.$element.find('.js-driver-manual-submit');
        this.$searchResultsList = this.$element.find('.js-search-results-list');
        this.$loader = this.$element.find('.loader');
        this.$vinNumber = this.$element.find('.js-driver-manual-search-vin');
        this.$language = this.$element.find('.js-driver-manual-search-language');
        this.$resultTitle = this.$element.find('.js-driver-manual-search-result-title');
        this.$errorMsgContainer = this.$element.find('.errormessage');
        this.collapsible = this.$element.find('.collapse');

        //defaults
        this.config = {
            apiSearch: 'api/feature/drivermanual/search',
            apiDownload: 'api/feature/drivermanual/download',
            lang: this.lang,
        };

        //init ajax helper
        this.ajax = new AjaxHandler({
            type: 'POST',
        });
    }

    /**
     * Initialize.
     */
    init() {
        // remove tpl class
        $('.tpl').detach();

        // TODO:
        this.$searchBtn.on('click', (e) => {
            e.preventDefault();

            if (!this.$vinNumber.val() || !this.$language.find('option:selected').val()) {
                // TODO
                // Validator feedback
            } else {
                this.$loader.fadeIn(150);

                this.getData().then(() => {
                    // Show results title
                    this.renderResultsTitle();

                    // render manuals
                    this.renderManual();

                    // Expand (only) element
                    this.toggleCollapse(e);

                    // Fade out loader
                    this.$loader.fadeOut(150);
                });
            }
        });
    }

    /**
     * gets question data needed to show questions to user
     */
    getData() {
        return new Promise((resolve) => {
            this.ajax
                .request({
                    url: '/' + this.config.lang + '/' + this.config.apiSearch,
                    data: JSON.stringify({
                        vinNumber: this.$vinNumber.val(),
                        language: this.$language.find('option:selected').val(),
                    }),
                })
                .then((response) => {
                    // store questiondata
                    this.data = $.extend(this.data, response);
                    this.resultsFound = this.data.ResultsFound;

                    resolve(response);
                })
                .catch((error) => {
                    if (this.$loader.is(':visible')) {
                        this.$loader.fadeOut(150);
                    }
                    this.$errorMsgContainer.html(error);
                });
        });
    }

    /**
     * render result title
     */
    renderResultsTitle() {
        if (this.resultsFound) {
            this.$resultTitle.html(this.data.ResultTitle).removeClass('is-hidden');
        } else {
            this.$resultTitle.html(this.data.NoResults).removeClass('is-hidden');
        }
    }

    /**
     * render manual items
     */
    renderManual() {
        let htmlArray = [];

        for (const manual of this.data.Manuals) {
            let templateHTML = this.$tpl;

            templateHTML = templateHTML.replace(/##MANUALTITLE##/g, manual.Title);
            templateHTML = templateHTML.replace(/##MANUALFILENAME##/g, manual.Filename);
            templateHTML = templateHTML.replace(
                /##MANUALLINK##/g,
                '/' +
                    this.config.lang +
                    '/' +
                    this.config.apiDownload +
                    '?container=' +
                    manual.Container +
                    '&filename=' +
                    manual.Filename
            );

            htmlArray.push(templateHTML);
        }

        this.$searchResultsList.html(htmlArray.join(''));
    }

    /**
     * Collapse/expand toggler.
     * @param {event} e Event.
     */
    toggleCollapse(e) {
        e.preventDefault();

        if (!this.$element.hasClass('is-open')) {
            this.$element.addClass('is-open');
            this.collapsible.collapse('show');
        }
    }
}

// register to Component Handler
window.ComponentHandler.register({
    constructor: DriverManualSearch,
    classAsString: 'DriverManualSearch',
    cssClass: 'js-driver-manual-search',
});

export default DriverManualSearch;
